import * as v from "valibot";

import {
  AcquiredDateChoiceEnum,
  MandatoryCurrencyToNumber,
  MediumEnum,
  OptionalCurrencyToNumber,
  YesNoUnknownEnum,
  dateISOString,
  trimmedString,
  yearIntToDate,
} from "@common/valibotTypes";

export const ImportedResaleSchema = (isParticipantCMO: boolean) => {
  const baseSchema = {
    artist_given_name: trimmedString,
    artist_middle_name: v.optional(v.string(), ""),
    artist_family_name: trimmedString,
    pseudonym: v.optional(trimmedString),
    country: trimmedString,
    artist_living: YesNoUnknownEnum,
    year_of_birth: v.optional(yearIntToDate),
    year_of_death: v.optional(yearIntToDate),
    title: trimmedString,
    medium: MediumEnum,
    dimensions_height: v.optional(v.number()),
    dimensions_width: v.optional(v.number()),
    details: v.optional(trimmedString),
    seller_acquired_work_post_8th_june_2010: AcquiredDateChoiceEnum,
    sale_price: MandatoryCurrencyToNumber,
    date_sold: dateISOString,
    artist_work_id: v.optional(trimmedString),
    gallery_work_id: v.optional(trimmedString),
  };

  if (isParticipantCMO) {
    return v.object({
      ...baseSchema,
      sale_price: OptionalCurrencyToNumber,
      royalty_amount: MandatoryCurrencyToNumber,
      artist_ipi: v.optional(trimmedString),
    });
  } else {
    return v.object(baseSchema);
  }
};

export type ImportedResaleInput = v.InferInput<ReturnType<typeof ImportedResaleSchema>>;
export type ImportedResaleOutput = v.InferOutput<ReturnType<typeof ImportedResaleSchema>>;

export interface ValidationItems {
  success: boolean;
  issues: v.ObjectIssue[];
}

export const validateImport = (importedResale: ImportedResaleInput, isParticipantCMO: boolean = false) => {
  const schema = ImportedResaleSchema(isParticipantCMO);
  const valibotParseResult = v.safeParse(schema, importedResale);
  return {
    result: valibotParseResult.output as ImportedResaleOutput,
    validation: {
      issues: valibotParseResult.issues,
      success: valibotParseResult.success,
    },
  };
};
